var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFashion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29814_1964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.29514 1.6001C5.49014 1.6001 5.65264 1.7426 5.71264 1.9301C6.02014 2.8976 6.92764 3.6001 8.00014 3.6001C9.07264 3.6001 9.98014 2.8976 10.2876 1.9301C10.3476 1.7426 10.5101 1.6001 10.7051 1.6001H11.0201C11.5826 1.6001 12.1251 1.7976 12.5576 2.1576L15.7126 4.7851C15.8776 4.9226 15.9801 5.1226 15.9976 5.3376C16.0151 5.5526 15.9451 5.7651 15.8026 5.9276L14.4026 7.5276C14.1176 7.8551 13.6226 7.8926 13.2876 7.6151L12.0001 6.5426V12.8001C12.0001 13.6826 11.2826 14.4001 10.4001 14.4001H5.60014C4.71764 14.4001 4.00014 13.6826 4.00014 12.8001V6.5426L2.71264 7.6151C2.38014 7.8926 1.88514 7.8551 1.59764 7.5276L0.19764 5.9276C0.0551402 5.7651 -0.0148598 5.5526 0.0026402 5.3376C0.0201402 5.1226 0.12264 4.9226 0.28764 4.7851L3.44264 2.1576C3.87514 1.7976 4.41764 1.6001 4.98014 1.6001H5.29514Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29814_1964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashion);
export default __webpack_public_path__ + "static/media/fashion.bf87adaa9b47a781e032908e67049311.svg";
export { ForwardRef as ReactComponent };